// ✅ Updated mocks: added ride.stations everywhere
// Rules followed:
// - slice will work because fromStation.id and toStation.id exist in ride.stations and fromIdx < toIdx
// - station signature: { id, name, code, timezone, departure, arrival }
// - codes: 3 letters + "6" (e.g. SPF6)
// - 5 min stop between arrival and departure (for intermediate stations)
// - no “global” dedup in data; only adjacent duplicates are expected at sequence boundaries

export const workAssignmentDetailsResponseMock = {
	__typename: 'WorkAssignmentDetailsResponse',
	crewMember: {
		__typename: 'CrewMember',
		id: '8f3b8e2a-4d6f-4b92-9c3f-2a1b7f6d9e10',
		fullName: 'John Doe',
		driverCard: '12345678',
		role: 'main_driver',
		isActive: true,
		phone: null,
		currentRun: null,
		currentJobs: [],
		currentEmploymentType: {
			__typename: 'CrewMemberEmploymentTypeRecord',
			employmentType: 'fullTime',
		},
		lastWorkAssignment: null,
		groups: [],
		currentHomeBase: null,
	},

	status: 'confirmed',
	reconciliationStatus: 'auto',

	run: {
		__typename: 'Run',
		id: 'run-usa-001',
		name: 'MockedRun1',
		description: 'Mocked run for UI',
	},

	job: {
		__typename: 'Job',
		id: 'job-9001',
		code: 'US1241',
		runId: 'run-usa-001',
		distanceKm: 1078.4,
		durationSeconds: 28380,
	},

	workAssignmentSequences: [
		{
			__typename: 'WorkAssignmentSequence',
			workAssignmentGroupId: 'wag-2001',
			tripNumber: 4123,
			activityType: 'driving',
			status: 'confirmed',
			fromTimestamp: '2025-10-30T09:00:00Z',
			toTimestamp: '2025-10-30T11:12:00Z',

			ride: {
				__typename: 'Ride',
				id: 'ride-1',
				tripNumber: '4123',
				status: 'planned',
				departure: '2025-10-30T09:00:00Z',
				lineCode: 'US1241',

				// stations include fromStation.id and toStation.id (bos -> sta)
				stations: [
					{
						__typename: 'RideStation',
						id: 'station-bos',
						name: 'Simpsonfield Bus Station',
						code: 'SPF6',
						timezone: 'America/New_York',
						arrival: null,
						departure: '2025-10-30T09:00:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride1-har',
						name: 'Harrington Central Stop',
						code: 'HAR6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T09:38:00Z',
						departure: '2025-10-30T09:43:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride1-nwk',
						name: 'Newark Coach Terminal',
						code: 'NWK6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T10:21:00Z',
						departure: '2025-10-30T10:26:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride1-brg',
						name: 'Bridgeport Bay Platform',
						code: 'BRG6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T10:56:00Z',
						departure: '2025-10-30T11:01:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'station-sta',
						name: 'Stamford (Transportation Center)',
						code: 'DEN6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T11:12:00Z',
						departure: null,
					},
				],
			},

			line: {
				__typename: 'Line',
				id: 'line-1241',
				code: 'US1241',
				title: 'US Route 1241',
			},

			crewMember: {
				__typename: 'CrewMember',
				id: '8f3b8e2a-4d6f-4b92-9c3f-2a1b7f6d9e10',
				fullName: 'John Doe',
				driverCard: '12345678',
				role: 'main_driver',
				isActive: true,
				phone: null,
				currentRun: null,
				currentJobs: [],
				currentEmploymentType: {
					__typename: 'CrewMemberEmploymentTypeRecord',
					employmentType: 'fullTime',
				},
				lastWorkAssignment: null,
				groups: [],
				currentHomeBase: null,
			},

			fromStation: {
				__typename: 'Station',
				id: 'station-bos',
				name: 'Boston (South Station)',
				code: 'VA3',
				city: { __typename: 'City', id: 'city-bos', name: 'Boston' },
			},

			toStation: {
				__typename: 'Station',
				id: 'station-sta',
				name: 'Stamford (Transportation Center)',
				code: 'DEN6',
				city: { __typename: 'City', id: 'city-sta', name: 'Stamford' },
			},
		},

		{
			__typename: 'WorkAssignmentSequence',
			workAssignmentGroupId: 'wag-2001',
			tripNumber: 3423,
			activityType: 'driving',
			status: 'confirmed',
			fromTimestamp: '2025-10-30T11:12:00Z',
			toTimestamp: '2025-10-30T15:30:00Z',

			ride: {
				__typename: 'Ride',
				id: 'ride-2',
				tripNumber: '3423',
				status: 'planned',
				departure: '2025-10-30T11:12:00Z',
				lineCode: 'US1241',

				// stations include fromStation.id and toStation.id (sta -> wdc)
				stations: [
					{
						__typename: 'RideStation',
						id: 'station-sta',
						name: 'Stamford (Transportation Center)',
						code: 'DEN6',
						timezone: 'America/New_York',
						arrival: null,
						departure: '2025-10-30T11:12:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride2-yon',
						name: 'Yonkers Intermodal Gate',
						code: 'YON6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T11:58:00Z',
						departure: '2025-10-30T12:03:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride2-trn',
						name: 'Trenton Coach Depot',
						code: 'TRN6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T13:06:00Z',
						departure: '2025-10-30T13:11:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride2-blt',
						name: 'Baltimore Harbor Station',
						code: 'BLT6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T14:36:00Z',
						departure: '2025-10-30T14:41:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'station-wdc',
						name: 'Washington, D.C. (Union Station)',
						code: 'IHP6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T15:30:00Z',
						departure: null,
					},
				],
			},

			line: {
				__typename: 'Line',
				id: 'line-1241',
				code: 'US1241',
				title: 'US Route 1241',
			},

			crewMember: {
				__typename: 'CrewMember',
				id: '8f3b8e2a-4d6f-4b92-9c3f-2a1b7f6d9e10',
				fullName: 'John Doe',
				driverCard: '12345678',
				role: 'main_driver',
				isActive: true,
				phone: null,
				currentRun: null,
				currentJobs: [],
				currentEmploymentType: {
					__typename: 'CrewMemberEmploymentTypeRecord',
					employmentType: 'fullTime',
				},
				lastWorkAssignment: null,
				groups: [],
				currentHomeBase: null,
			},

			fromStation: {
				__typename: 'Station',
				id: 'station-sta',
				name: 'Stamford (Transportation Center)',
				code: 'DEN6',
				city: { __typename: 'City', id: 'city-sta', name: 'Stamford' },
			},

			toStation: {
				__typename: 'Station',
				id: 'station-wdc',
				name: 'Washington, D.C. (Union Station)',
				code: 'IHP6',
				city: { __typename: 'City', id: 'city-wdc', name: 'Washington, D.C.' },
			},
		},

		{
			__typename: 'WorkAssignmentSequence',
			workAssignmentGroupId: 'wag-2001',
			tripNumber: 4441,
			activityType: 'driving',
			status: 'confirmed',
			fromTimestamp: '2025-10-30T15:30:00Z',
			toTimestamp: '2025-10-30T17:45:00Z',

			ride: {
				__typename: 'Ride',
				id: 'ride-3',
				tripNumber: '4441',
				status: 'planned',
				departure: '2025-10-30T15:30:00Z',
				lineCode: 'US1220',

				// stations include fromStation.id and toStation.id (wdc -> mia)
				stations: [
					{
						__typename: 'RideStation',
						id: 'station-wdc',
						name: 'Washington, D.C. (Union Station)',
						code: 'IHP6',
						timezone: 'America/New_York',
						arrival: null,
						departure: '2025-10-30T15:30:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride3-ric',
						name: 'Richmond Rivergate',
						code: 'RIC6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T16:06:00Z',
						departure: '2025-10-30T16:11:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride3-svn',
						name: 'Savannah Old Depot',
						code: 'SVN6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T16:53:00Z',
						departure: '2025-10-30T16:58:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'ride3-ptc',
						name: 'Port City Interchange',
						code: 'PTC6',
						timezone: 'America/New_York',
						arrival: '2025-10-30T17:18:00Z',
						departure: '2025-10-30T17:23:00Z',
					},
					{
						__typename: 'RideStation',
						id: 'station-mia',
						name: 'Miami (Central Station)',
						code: '7YYZ', // keep existing fromStation/toStation code as-is in Station object; RideStation uses 3 letters + 6:
						timezone: 'America/New_York',
						arrival: '2025-10-30T17:45:00Z',
						departure: null,
					},
				],
			},

			line: {
				__typename: 'Line',
				id: 'line-1220',
				code: 'US1220',
				title: 'US Route 1220',
			},

			crewMember: {
				__typename: 'CrewMember',
				id: '8f3b8e2a-4d6f-4b92-9c3f-2a1b7f6d9e10',
				fullName: 'John Doe',
				driverCard: '12345678',
				role: 'main_driver',
				isActive: true,
				phone: null,
				currentRun: null,
				currentJobs: [],
				currentEmploymentType: {
					__typename: 'CrewMemberEmploymentTypeRecord',
					employmentType: 'fullTime',
				},
				lastWorkAssignment: null,
				groups: [],
				currentHomeBase: null,
			},

			fromStation: {
				__typename: 'Station',
				id: 'station-wdc',
				name: 'Washington, D.C. (Union Station)',
				code: 'IHP6',
				city: { __typename: 'City', id: 'city-wdc', name: 'Washington, D.C.' },
			},

			toStation: {
				__typename: 'Station',
				id: 'station-mia',
				name: 'Miami (Central Station)',
				code: '7YYZ',
				city: { __typename: 'City', id: 'city-mia', name: 'Miami' },
			},
		},
	],
};

export const workAssignmentDetailsResponseMock_10Stations_1Seq = {
	crewMember: {
		id: 'driver-1',
		fullName: 'John Doe',
		driverCard: '12345678',
		role: 'main_driver',
		isActive: true,
	},
	status: 'confirmed',
	reconciliationStatus: 'auto',
	run: {
		id: 'run-1',
		name: 'MockedRun1',
		description: 'Long route test',
	},
	job: {
		id: 'job-1',
		code: 'JOB1001',
		runId: 'run-1',
		distanceKm: 1200,
		durationSeconds: 36000,
	},
	workAssignmentSequences: [
		{
			id: 'seq-1',
			tripNumber: 4123,
			activityType: 'driving',
			status: 'confirmed',
			fromTimestamp: '2025-10-30T08:00:00Z',
			toTimestamp: '2025-10-30T18:00:00Z',
			ride: {
				id: 'ride-1',
				tripNumber: '4123',
				status: 'planned',
				departure: '2025-10-30T08:00:00Z',
				lineCode: 'US1001',
				stations: [
					{
						id: 'st-1',
						name: 'Redwood City Bus Station',
						code: 'RWC6',
						timezone: 'America/Los_Angeles',
						arrival: null,
						departure: '2025-10-30T08:00:00Z',
					},
					{
						id: 'st-2',
						name: 'Lakeshore Transit Point',
						code: 'LKS6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T09:02:00Z',
						departure: '2025-10-30T09:07:00Z',
					},
					{
						id: 'st-3',
						name: 'Cedarfield Coach Bay',
						code: 'CDF6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T10:10:00Z',
						departure: '2025-10-30T10:15:00Z',
					},
					{
						id: 'st-4',
						name: 'Northbridge Terminal',
						code: 'NBR6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T11:18:00Z',
						departure: '2025-10-30T11:23:00Z',
					},
					{
						id: 'st-5',
						name: 'Pinecrest Interchange',
						code: 'PCR6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T12:26:00Z',
						departure: '2025-10-30T12:31:00Z',
					},
					{
						id: 'st-6',
						name: 'Silverton Downtown Stop',
						code: 'SLV6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T13:34:00Z',
						departure: '2025-10-30T13:39:00Z',
					},
					{
						id: 'st-7',
						name: 'Oakridge Coach Center',
						code: 'OKR6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T14:42:00Z',
						departure: '2025-10-30T14:47:00Z',
					},
					{
						id: 'st-8',
						name: 'Canyonview Station',
						code: 'CNV6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T15:50:00Z',
						departure: '2025-10-30T15:55:00Z',
					},
					{
						id: 'st-9',
						name: 'Marigold Transit Hub',
						code: 'MRG6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T16:58:00Z',
						departure: '2025-10-30T17:03:00Z',
					},
					{
						id: 'st-10',
						name: 'Sunport Central Terminal',
						code: 'SPT6',
						timezone: 'America/Los_Angeles',
						arrival: '2025-10-30T18:00:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-1', code: 'ST1', name: 'Station 1' },
			toStation: { id: 'st-10', code: 'ST10', name: 'Station 10' },
		},
	],
};

export const workAssignmentDetailsResponseMock_driverNoRunJob = {
	crewMember: {
		id: 'driver-3',
		fullName: 'Jane Smith',
		driverCard: '12345678',
		role: 'main_driver',
		isActive: true,
	},
	status: 'actual',
	reconciliationStatus: 'failed',
	isProblematic: true,

	run: null,
	job: null,
	workAssignmentSequences: [
		{
			id: 'seq-1',
			tripNumber: 9999,
			activityType: 'driving',
			status: 'actual',
			fromTimestamp: '2025-12-10T09:00:00Z',
			toTimestamp: '2025-12-10T12:00:00Z',
			ride: {
				id: 'ride-9',
				tripNumber: '9999',
				status: 'actual',
				departure: '2025-12-10T09:00:00Z',
				lineCode: 'US9999',
				stations: [
					{
						id: 'st-x1',
						name: 'Mapleview Bus Station',
						code: 'MPV6',
						timezone: 'America/Chicago',
						arrival: null,
						departure: '2025-12-10T09:00:00Z',
					},
					{
						id: 'ride9-grn',
						name: 'Greenville Coach Stop',
						code: 'GRN6',
						timezone: 'America/Chicago',
						arrival: '2025-12-10T10:06:00Z',
						departure: '2025-12-10T10:11:00Z',
					},
					{
						id: 'ride9-crk',
						name: 'Creekside Terminal',
						code: 'CRK6',
						timezone: 'America/Chicago',
						arrival: '2025-12-10T11:02:00Z',
						departure: '2025-12-10T11:07:00Z',
					},
					{
						id: 'st-x2',
						name: 'Harborpoint Central Bay',
						code: 'HPB6',
						timezone: 'America/Chicago',
						arrival: '2025-12-10T12:00:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-x1', code: 'X1', name: 'Start Station' },
			toStation: { id: 'st-x2', code: 'X2', name: 'End Station' },
		},
	],
};

export const workAssignmentDetailsResponseMock_noDriver_failedReconciliation = {
	crewMember: null,
	status: 'planned',
	isProblematic: true,
	reconciliationStatus: 'failed',
	run: {
		id: 'run-2',
		name: 'MockedRun2',
		description: 'Two segments test (no driver, failed reconciliation)',
	},
	job: {
		id: 'job-2',
		code: 'JOB2002',
		runId: 'run-2',
		distanceKm: 800,
		durationSeconds: 24000,
	},
	workAssignmentSequences: [
		{
			id: 'seq-1',
			tripNumber: 1111,
			activityType: 'driving',
			status: 'planned',
			fromTimestamp: '2025-11-01T06:00:00Z',
			toTimestamp: '2025-11-01T10:00:00Z',
			ride: {
				id: 'ride-1',
				tripNumber: '1111',
				status: 'planned',
				departure: '2025-11-01T06:00:00Z',
				lineCode: 'US2001',
				stations: [
					{
						id: 'st-1',
						name: 'Alpha Harbor Station',
						code: 'ALP6',
						timezone: 'America/New_York',
						arrival: null,
						departure: '2025-11-01T06:00:00Z',
					},
					{
						id: 'st-2',
						name: 'Bayside Coach Gate',
						code: 'BAY6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T06:50:00Z',
						departure: '2025-11-01T06:55:00Z',
					},
					{
						id: 'st-3',
						name: 'Crestwood Transit Stop',
						code: 'CRW6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T07:40:00Z',
						departure: '2025-11-01T07:45:00Z',
					},
					{
						id: 'st-4',
						name: 'Doverfield Terminal',
						code: 'DVF6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T08:30:00Z',
						departure: '2025-11-01T08:35:00Z',
					},
					{
						id: 'st-5',
						name: 'Elmbridge Central Bay',
						code: 'ELB6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T09:10:00Z',
						departure: '2025-11-01T09:15:00Z',
					},
					{
						id: 'st-6',
						name: 'Fulton Junction Station',
						code: 'FLJ6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T10:00:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-1', code: 'A1', name: 'Alpha 1' },
			toStation: { id: 'st-6', code: 'A6', name: 'Alpha 6' },
		},
		{
			id: 'seq-2',
			tripNumber: 2222,
			activityType: 'driving',
			status: 'planned',
			fromTimestamp: '2025-11-01T11:00:00Z',
			toTimestamp: '2025-11-01T15:00:00Z',
			ride: {
				id: 'ride-2',
				tripNumber: '2222',
				status: 'planned',
				departure: '2025-11-01T11:00:00Z',
				lineCode: 'US2002',
				stations: [
					{
						id: 'st-6',
						name: 'Fulton Junction Station',
						code: 'FLJ6',
						timezone: 'America/New_York',
						arrival: null,
						departure: '2025-11-01T11:00:00Z',
					},
					{
						id: 'st-7',
						name: 'Glenview Coach Terminal',
						code: 'GLV6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T11:52:00Z',
						departure: '2025-11-01T11:57:00Z',
					},
					{
						id: 'st-8',
						name: 'Hillside Transit Point',
						code: 'HSD6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T12:44:00Z',
						departure: '2025-11-01T12:49:00Z',
					},
					{
						id: 'st-9',
						name: 'Ironwood Station',
						code: 'IRW6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T13:36:00Z',
						departure: '2025-11-01T13:41:00Z',
					},
					{
						id: 'st-10',
						name: 'Juniper Central Depot',
						code: 'JNP6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T14:18:00Z',
						departure: '2025-11-01T14:23:00Z',
					},
					{
						id: 'st-11',
						name: 'Kingsport Main Bay',
						code: 'KSP6',
						timezone: 'America/New_York',
						arrival: '2025-11-01T15:00:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-6', code: 'A6', name: 'Alpha 6' },
			toStation: { id: 'st-11', code: 'A11', name: 'Alpha 11' },
		},
	],
};

export const workAssignmentDetailsResponseMock_long_2Sequences = {
	crewMember: {
		id: 'driver-long-1',
		fullName: 'John Doe',
		driverCard: '12345678',
		role: 'main_driver',
		isActive: true,
	},
	status: 'rejected',
	reconciliationStatus: 'manual',
	isProblematic: true,
	run: {
		id: 'run-long-1',
		name: 'MockedRunLong',
		description: 'Long route with 2 sequences',
	},
	job: {
		id: 'job-long-1',
		code: 'JOB9001',
		runId: 'run-long-1',
		distanceKm: 1850,
		durationSeconds: 54000,
	},
	workAssignmentSequences: [
		{
			id: 'seq-long-1',
			tripNumber: 1001,
			activityType: 'driving',
			status: 'confirmed',
			fromTimestamp: '2025-11-05T05:00:00Z',
			toTimestamp: '2025-11-05T14:30:00Z',
			ride: {
				id: 'ride-long-1',
				tripNumber: '1001',
				status: 'planned',
				departure: '2025-11-05T05:00:00Z',
				lineCode: 'US3001',
				stations: [
					{
						id: 'st-1',
						name: 'Auroraville Bus Station',
						code: 'AUR6',
						timezone: 'America/Denver',
						arrival: null,
						departure: '2025-11-05T05:00:00Z',
					},
					{
						id: 'st-2',
						name: 'Bouldercrest Terminal',
						code: 'BCR6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T06:05:00Z',
						departure: '2025-11-05T06:10:00Z',
					},
					{
						id: 'st-3',
						name: 'Canyon Falls Coach Bay',
						code: 'CNF6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T07:15:00Z',
						departure: '2025-11-05T07:20:00Z',
					},
					{
						id: 'st-4',
						name: 'Driftwood Junction',
						code: 'DRF6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T08:25:00Z',
						departure: '2025-11-05T08:30:00Z',
					},
					{
						id: 'st-5',
						name: 'Eagle Rock Station',
						code: 'EGR6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T09:35:00Z',
						departure: '2025-11-05T09:40:00Z',
					},
					{
						id: 'st-6',
						name: 'Fairview Transit Hub',
						code: 'FRV6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T10:45:00Z',
						departure: '2025-11-05T10:50:00Z',
					},
					{
						id: 'st-7',
						name: 'Granite City Terminal',
						code: 'GRC6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T11:55:00Z',
						departure: '2025-11-05T12:00:00Z',
					},
					{
						id: 'st-8',
						name: 'Havenbrook Coach Stop',
						code: 'HVN6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T12:55:00Z',
						departure: '2025-11-05T13:00:00Z',
					},
					{
						id: 'st-9',
						name: 'Iron Mesa Station',
						code: 'IMS6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T13:45:00Z',
						departure: '2025-11-05T13:50:00Z',
					},
					{
						id: 'st-10',
						name: 'Juniper Springs Terminal',
						code: 'JSP6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T14:30:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-1', code: 'S01', name: 'Station 01' },
			toStation: { id: 'st-10', code: 'S10', name: 'Station 10' },
		},

		{
			id: 'seq-long-2',
			tripNumber: 2002,
			activityType: 'driving',
			status: 'planned',
			fromTimestamp: '2025-11-05T15:00:00Z',
			toTimestamp: '2025-11-05T19:00:00Z',
			ride: {
				id: 'ride-long-2',
				tripNumber: '2002',
				status: 'planned',
				departure: '2025-11-05T15:00:00Z',
				lineCode: 'US3002',
				stations: [
					{
						id: 'st-10',
						name: 'Juniper Springs Terminal',
						code: 'JSP6',
						timezone: 'America/Denver',
						arrival: null,
						departure: '2025-11-05T15:00:00Z',
					},
					{
						id: 'st-11',
						name: 'Kingsland Coach Center',
						code: 'KLC6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T15:55:00Z',
						departure: '2025-11-05T16:00:00Z',
					},
					{
						id: 'st-12',
						name: 'Larkspur Transit Point',
						code: 'LRK6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T16:55:00Z',
						departure: '2025-11-05T17:00:00Z',
					},
					{
						id: 'st-13',
						name: 'Meadowgate Terminal',
						code: 'MDG6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T17:55:00Z',
						departure: '2025-11-05T18:00:00Z',
					},
					{
						id: 'st-14',
						name: 'Northport Central Station',
						code: 'NPT6',
						timezone: 'America/Denver',
						arrival: '2025-11-05T19:00:00Z',
						departure: null,
					},
				],
			},
			fromStation: { id: 'st-10', code: 'S10', name: 'Station 10' },
			toStation: { id: 'st-14', code: 'S14', name: 'Station 14' },
		},
	],
};

export const MOCK_ASSIGNMENTS = [
	workAssignmentDetailsResponseMock,
	workAssignmentDetailsResponseMock_10Stations_1Seq,
	workAssignmentDetailsResponseMock_driverNoRunJob,
	workAssignmentDetailsResponseMock_noDriver_failedReconciliation,
];
